import type { ReactNode } from 'react';

import { Box } from '@mui/material';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

type DataHubSectionProps = {
  children: ReactNode;
  gap?: number | string;
  scroll?: boolean;
  sx?: SxProps<Theme>;
};

export const DataHubSection = ({ children, gap = 2, scroll = false, sx }: DataHubSectionProps) => {
  return (
    <Box
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          gap,
          ...(scroll ? { overflow: 'auto' } : {})
        },
        ...normalizeSx(sx)
      ]}
    >
      {children}
    </Box>
  );
};
